import { ActiveScreen } from 'app/copied/constants/common';
import { useTailorIsOpen } from 'app/hooks/useTailorIsOpen';
import { useRef } from 'react';
import { useLocation } from 'react-router-dom';

const getView = (pathname: string): string => {
  let view = 'Unknown';

  if (ActiveScreen[pathname as keyof typeof ActiveScreen]) {
    view = ActiveScreen[pathname as keyof typeof ActiveScreen];
  } else {
    const dynamicRoute = Object.keys(ActiveScreen).find((route) => {
      if (route.includes(':')) {
        const baseRoute = route.split('/:')[0];
        return pathname.startsWith(baseRoute);
      }
      return false;
    });

    if (dynamicRoute) {
      view = ActiveScreen[dynamicRoute as keyof typeof ActiveScreen];
    }
  }

  return view;
};

const useActiveScreen = (): {
  activeScreen: string;
  previousScreen: string;
} => {
  const { isOpen } = useTailorIsOpen();
  const location = useLocation();

  const previousScreen = useRef('');
  const activeScreen = useRef('WidgetClosed');

  const currentActiveScreen = isOpen ? getView(location.pathname) : 'WidgetClosed';

  if (currentActiveScreen !== activeScreen.current) {
    previousScreen.current = activeScreen.current;
    activeScreen.current = currentActiveScreen;
  }

  return {
    activeScreen: activeScreen.current,
    previousScreen: previousScreen.current,
  };
};

export default useActiveScreen;
